export const DATALINK_HISTORY = [
  {
    label: 'Created',
    key: 'created',
    width: '20%',
    filter: {
      filterName: 'dateFormat',
      params: 'Y/MM/dd HH:mm' // todo: at the moment we can set only one param
    }
  },
  {
    label: 'Original Files',
    key: 'FileCount',
    custom: true
  },
  {
    label: 'Uploaded',
    key: 'file_uploaded'
  },
  {
    label: 'Status',
    key: 'Status',
    custom: true
  },
  {
    label: 'Sent Date',
    key: 'sent',
    filter: {
      filterName: 'dateFormat',
      params: 'Y/MM/dd HH:mm' // todo: at the moment we can set only one param
    }
  },
  {
    label: '',
    key: 'Control',
    width: '20%',
    custom: true
  }
]

export const DATALINK_DETAILS = [
  { key: 'type', label: 'Category' },
  { key: 'name', label: 'Item Name' },
  { key: 'product_id', label: 'Product ID' },
  { key: 'size', label: 'Size' },
  { key: 'data.height', label: 'Height' },
  { key: 'data.bust', label: 'Bust' },
  { key: 'data.sleeve', label: 'Sleeve' },
  { key: 'data.shoulder', label: 'shoulder' },
  { key: 'data.waist', label: 'Waist' },
  { key: 'data.thigh', label: 'Thigh' },
  { key: 'data.hip', label: 'Hip' },
  { key: 'data.hem', label: 'Hem' },
  { key: 'data.inseam', label: 'Inseam' },
  { key: 'data.frontRise', label: 'Front Rise' },
  { key: 'data.armOpening', label: 'Arm Opening' },
  { key: 'data.sleeveOpening', label: 'Sleeve Opening' },
  { key: 'data.knee', label: 'Knee' },
  { key: 'data.legOpening', label: 'Leg Opening' },
  { key: 'data.backRise', label: 'Back Rise' },
  { key: 'data.waistHeight', label: 'Waist Height' },
  { key: 'data.collar', label: 'Collar' },
  { key: 'data.bicep', label: 'Bicep' },
  { key: 'data.depth', label: 'Depth' },
  { key: 'data.width', label: 'Height' },
  { key: 'data.topWidth', label: 'Width' },
  { key: 'data.handleDrop', label: 'Handle Drop' },
  { key: 'data.handleWidth', label: 'Handle Width' },
  { key: 'data.lensWidth', label: 'Lens Width' },
  { key: 'data.temple', label: 'Temple' },
  { key: 'data.frameWidth', label: 'Frame Width' },
  { key: 'data.bridge', label: 'Bridge' },
  { key: 'data.frameWidth', label: 'FrameWidth' }
]

export const ITEM_COVERAGE_DETAILS = [
  {
    key: 'statusKey',
    label: 'Status',
    custom: true
  },
  {
    key: 'product_type_id',
    label: 'Category',
    custom: true
  },
  { key: 'name', label: 'Item Name' },
  { key: 'external_id', label: 'Product ID' },
  { key: 'sizeName', label: 'Size' },
  { key: 'sizes.height', label: 'Height' },
  { key: 'sizes.bust', label: 'Bust' },
  { key: 'sizes.sleeve', label: 'Sleeve' },
  { key: 'sizes.shoulder', label: 'shoulder' },
  { key: 'sizes.waist', label: 'Waist' },
  { key: 'sizes.thigh', label: 'Thigh' },
  { key: 'sizes.hip', label: 'Hip' },
  { key: 'sizes.hem', label: 'Hem' },
  { key: 'sizes.inseam', label: 'Inseam' },
  { key: 'sizes.frontRise', label: 'Front Rise' },
  { key: 'sizes.armOpening', label: 'Arm Opening' },
  { key: 'sizes.sleeveOpening', label: 'Sleeve Opening' },
  { key: 'sizes.knee', label: 'Knee' },
  { key: 'sizes.legOpening', label: 'Leg Opening' },
  { key: 'sizes.backRise', label: 'Back Rise' },
  { key: 'sizes.waistHeight', label: 'Waist Height' },
  { key: 'sizes.collar', label: 'Collar' },
  { key: 'sizes.bicep', label: 'Bicep' },
  { key: 'sizes.depth', label: 'Depth' },
  { key: 'sizes.width', label: 'Height' },
  { key: 'sizes.topWidth', label: 'Width' },
  { key: 'sizes.handleDrop', label: 'Handle Drop' },
  { key: 'sizes.handleWidth', label: 'Handle Width' },
  { key: 'sizes.lensWidth', label: 'Lens Width' },
  { key: 'sizes.temple', label: 'Temple' },
  { key: 'sizes.frameWidth', label: 'Frame Width' },
  { key: 'sizes.bridge', label: 'Bridge' },
  { key: 'sizes.frameWidth', label: 'FrameWidth' }
]
